export enum OfferModalLatestNavType {
    NEXT = "next",
    PREV = "prev"
}
export enum OfferModalLatestNavType {
    NEXT = "next",
    PREV = "prev"
}
